import Flash from "@shared/services/flashv2";
import { EventTracking } from "@shared/services/event_tracking/events";
import { ErrorMessageEntity } from "@shared/services/event_tracking/entities";
import type { RetailerLiquorLicenseType, RetailerType } from "@shared/types/Retailer";

const { trackEvent } = EventTracking;

export const businessDetailsErrorsMap: { [key: string]: { [key: string]: string } } = {
  name: {
    required: "Business Name is required",
  },
  address1: {
    required: "Business Address is required",
  },
  city: {
    required: "City is required",
  },
  zip: {
    required: "Zip is required",
  },
  state: {
    required: "State is required",
    isProviAvailableInState:
      "Provi is not available in your market. Contact us at support@provi.com to find out when we'll be available.",
  },
  license_type: {
    required: "License Type is required",
  },
  liquor_license_ack: {
    isValidAck: "Required",
  },
};

export const retailerLiquorLicenseTypes: RetailerLiquorLicenseType[] = [
  {
    text: "On site - beverages sold for consumption at location",
    value: "on_premise",
  },
  {
    text: "Off site - beverages sold for consumption off-premise",
    value: "off_premise",
  },
  {
    text: "Both",
    value: "on_and_off_premise",
  }
];

export const setErrors = (store, messages: string[]): void => {
  store.errors.update(() => {
    messages.forEach(message => {
      if (message === "Email has already been taken") {
        message = `This email address is already in use. <a href='/users/sign_in?ref=1'
          onclick=\"window.location.href='/users/sign_in?ref=1';\">Login</a>
          or <a href='/users/password/new?ref=1'
          onclick=\"window.location.href='/users/password/new?ref=1';\">recover your password</a>`;
      }

      Flash.now({ header: "Error", message, rawHtml: true, type: "error" });
    });

    trackErrorImpressions(messages);

    return { messages };
  });
};

export const trackErrorImpressions = (messages: string[]): void => {
  trackEvent("begin_to_render", [new ErrorMessageEntity({ messages })]);
};

export const hasSevenFiftyPartnerSource = (retailers: RetailerType[]): boolean => {
  return !!retailers?.length && retailers[0]?.partner_source === "seven_fifty";
};

export const userFriendlyErrors = (
  formErrors: string[],
  errorsMap: { [key: string]: { [key: string]: string } },
): string[] => {
  return formErrors.map(errorName => {
    const [key, error] = errorName.split(".");

    return errorsMap[key][error];
  });
};
